import {LocationsService} from './../../../services/locations';
import {Component} from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {NavController, LoadingController, AlertController} from 'ionic-angular';
import {AuthService} from './../../../services/auth';
import {MapService} from './../../../services/map';
import {TabsPage} from './../../tabs/tabs';
import {SignInPage} from '../sign-in/sign-in';
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {PlatformService} from './../../../services/platform';
import {SessionService} from '../../../services/session';

@Component({
  selector: 'page-register',
  templateUrl: 'register.html'
})
export class RegisterPage {
  tabsPage = TabsPage;
  signInPage = SignInPage;
  userForm: FormGroup;

  constructor(
    public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public authService: AuthService,
    public mapService: MapService,
    public iab: InAppBrowser,
    public platformService: PlatformService,
    public sessionService: SessionService,
    public locationsService: LocationsService
  ) {
  }

  ngOnInit() {
    this.initializeForm();
  }

  // Starts the user form includes default value, validators list, async validators list
  initializeForm() {
    this.userForm = new FormGroup({
      name: new FormControl(null, [
        Validators.required /*, this.forbiddenNames.bind(this)*/
      ]),
      lastname: new FormControl(null, Validators.required),
      email: new FormControl(
        null,
        [Validators.required, Validators.email],
        [this.forbiddenEmails.bind(this)]
      ),
      password: new FormControl(null, [
        Validators.required,
        Validators.minLength(8)
      ]),
      phone: new FormControl(
        null,
        [Validators.required, Validators.minLength(6)],
        [this.forbiddenPhones.bind(this)]
      ),
      city_id: new FormControl(this.locationsService.translate('defaultCityId'), Validators.required),
      birthday: new FormControl(null, Validators.required),
      acceptTerms: new FormControl(false, Validators.required),
      gender: new FormControl('female', Validators.required)
    });
  }

  //Asyncronous validator checks if email already exists -> used in userForm.email
  forbiddenEmails(control: FormControl): Promise<any> {
    const promise = new Promise<any>((resolve, reject) => {
      this.authService
        .checkAvailability('email', control.value)
        .then(() => {
          resolve(null);
        })
        .catch(() => {
          resolve({emailIsInUse: true});
        });
    });
    return promise;
  }

  //Asyncronous validator checks if phonr already exists -> used in userForm.phone
  forbiddenPhones(control: FormControl): Promise<any> {
    const promise = new Promise<any>((resolve, reject) => {
      this.authService
        .checkAvailability('phone', control.value)
        .then(() => {
          resolve(null);
        })
        .catch(() => {
          resolve({phoneIsInUse: true});
        });
    });
    return promise;
  }

  //Submits Form-> used when clicking "Crear cuenta"
  onRegister() {
    //presents loader
    let loading = this.loadingCtrl.create({
      content: 'Creando Cuenta...'
    });
    loading.present();
    //register user
    this.authService
      .register(this.userForm.value)
      .then(() => {
        //change page and dismiss loader
        this.navCtrl.setRoot(this.tabsPage);
        loading.dismiss();
      })
      .catch(err => {
        //displays alert and dismiss loader
        this.sessionService.reportError(
          'registerPage',
          'onRegister()',
          err,
          this.userForm.value.email
        );
        let alert = this.alertCtrl.create({
          title: 'Error al iniciar sesión',
          message: err.error.errors.full_messages[0],
          buttons: [
            {
              text: 'Ok'
            }
          ]
        });
        loading.dismiss();
        alert.present();
      });
  }

  //changes page -> used when clicking "Iniciar sesión"
  goTo(page) {
    this.navCtrl.push(page);
  }

  openBrowser(url) {
    this.iab.create(url, '_blank');
  }

  ionViewDidLoad() {
    window['page'] = 'RegisterPage'; // for GA
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/register/register.ts